import type { AudioEngine, AudioTrack } from './audio-service';

/**
 * An engine for a device that cannot make a sound, and for every test environment.
 *
 * Not a mock: it is the shipped fallback. A browser without Web Audio, or one that refuses to
 * build a context, gets a quiet sitting rather than a broken one — the same shape the narration
 * service already takes on a device with no voice. Everything above it, including the ducking
 * contract and the disposal discipline, behaves exactly as it does with a real engine, so there is
 * no second code path for the quiet case to drift down.
 */
export function createSilentAudioEngine(): AudioEngine {
  const inert: AudioTrack = {
    setGain: () => undefined,
    restart: () => undefined,
    stop: () => undefined,
  };

  return {
    resume: () => Promise.resolve(),
    setMasterGain: () => undefined,
    play: () => inert,
    close: () => undefined,
  };
}
